module.exports = __webpack_public_path__ + "cbad0564c9c275635d21fe07fae814d9.MP3";